<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { availableLocales, t } = useI18n();

function flagClass(locale: string) {
    switch (locale) {
        case 'en':
            return 'gb';
        default:
            return locale;
    }
}

function tooltip(locale: string) {
    return t(locale);
}
</script>

<template>
    <div class="app-locale-select flex gap-2">
        <div
            v-for="locale in availableLocales"
            :key="locale"
            v-tooltip.top="tooltip(locale)"
            @click="$i18n.locale = locale"
        >
            <span
                class="fp fp-lg fp-rounded locale-select-item"
                :class="[
                    flagClass(locale),
                    { selected: locale === $i18n.locale },
                ]"
            ></span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.locale-select-item {
    filter: grayscale(1);
    opacity: 0.3;
    cursor: pointer;

    &:hover {
        filter: grayscale(0.4);
        opacity: 0.8;
    }

    &.selected {
        filter: grayscale(0);
        opacity: 1;
    }
}
.p-tooltip {
    z-index: 6000;
}
</style>
<!-- eslint-disable @intlify/vue-i18n/no-unused-keys -->
<i18n>
    {
        "en": {
            "nl": "Dutch",
            "en": "English",
            "fr": "French"
        },
        "nl": {
            "nl": "Nederlands",
            "en": "Engels",
            "fr": "Frans"
        },
        "fr": {
            "nl": "Néerlandais",
            "en": "Anglais",
            "fr": "Français"
        }
    }
</i18n>
